import { render, staticRenderFns } from "./UkrTreasuresTable.vue?vue&type=template&id=d41d5506&scoped=true"
import script from "./UkrTreasuresTable.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41d5506",
  null
  
)

export default component.exports